import React from 'react';
import styles from './ViewUserModal.module.css';
import Modal from '../../Atoms/Modal/Modal';
import ModalChildrenContainer from '../../Atoms/Modal/ModalChildrenContainer';
import Buttons from '../../Atoms/Buttons/Buttons';

const UserModal = ({
  handleOnClose,
  setIsModalOpen,
  setDeleteMode,
  eachUser,
  setModalMode,
}) => {
  return (
    <Modal
      onClose={handleOnClose}
      title={''}
      width="44rem"
      scrollY="auto"
      closeWhite={false}
    >
      <ModalChildrenContainer>
        <div className={`${styles['modalRow']} ${styles['bordered']} `}>
          <div className={`${styles['w-50']}`}>
            <h6 className={`${styles['label']}`}>الاسم الأول</h6>
            <h3 className={`${styles['text']}`}>{eachUser.fullName_En}</h3>
          </div>

          <div className={`${styles['w-50']}`}>
            <h6 className={`${styles['label']}`}>اسم العائلة</h6>
            <h3 className={`${styles['text']}`}>{eachUser.fullName_AR}</h3>
          </div>
        </div>

        <div className={`${styles['modalRow']} ${styles['bordered']}`}>
          <div className={`${styles['w-100']}`}>
            <h6 className={`${styles['label']}`}>البريد الإلكتروني</h6>
            <h3 className={`${styles['text']}`}>{eachUser.email}</h3>
          </div>
        </div>

        <div className={`${styles['modalRow']} ${styles['bordered']}`}>
          <div className={`${styles['w-100']}`}>
            <h6 className={`${styles['label']}`}>رقم الجوال</h6>
            <h3 className={`${styles['text']}`}>{eachUser.mobile}</h3>
          </div>
        </div>

        <div className={`${styles['modalRow']}`}>
          <div className={`${styles['w-100']}`}>
            <h6 className={`${styles['label']}`}>الصفحات المخصصة</h6>
            <h3 className={`${styles['text']}`}>{eachUser.userRoles}</h3>
          </div>
        </div>

        <div className={`${styles['footer-container']}`}>
          <Buttons
            text="تعديل"
            handleOnClick={() => {
              handleOnClose();
              setIsModalOpen(true);
              setModalMode('Edit');
            }}
            rounded
            width={200}
          />
          {'   '}
          <Buttons
            text="حذف"
            handleOnClick={() => {
              // handleOnClose();
              setDeleteMode(true);
            }}
            rounded
            color={'#D72222'}
            width={200}
          />
        </div>
      </ModalChildrenContainer>
    </Modal>
  );
};

export default UserModal;
